<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card elevation="0" min-height="300px">
        <v-form v-model="valid" ref="collectForm">
          <v-card-title>
            Collect Assignment &nbsp;
            <v-chip color="primary">{{itemId}}</v-chip>
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="4">
                <v-row no-gutters>
                  <v-col cols="12" md="12">
                    <v-textarea
                      v-model="collect.remark"
                      label="Remark"
                      rows="3"
                      prepend-icon="description"
                    />
                  </v-col>
                  <v-col cols="12" md="10">
                    <v-autocomplete
                      name="employee"
                      v-model="collect.employeeDto.userAccountId"
                      label="Employee *"
                      :rules="employeeRule"
                      prepend-icon="person_outline"
                      :items="employee"
                      autocomplete="off"
                      item-value="userAccountId"
                      item-text="profileName"
                    />
                  </v-col>
                  <v-col cols="12" md="2" class="pa-2">
                    <v-btn icon>
                      <v-icon @click="clickHistoryEmployee()" color="primary">history</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4" offset="3">
                <v-row no-gutters>
                  <v-col cols="12" md="12">
                    <v-alert border="left" colored-border color="black" elevation="1">
                      <ul>
                        <li>Date : {{collect.date | formatDateTime($moment)}}</li>
                        <li>ModifiedDate : {{collect.modifiedDate | formatDateTime($moment)}}</li>
                      </ul>
                    </v-alert>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" v-if="collect.collectId == 0" @click="beforeSaveCollect">
              <v-icon>save</v-icon>Save
            </v-btn>
            <v-btn color="primary" v-else @click="beforeUpdateCollect">
              <v-icon>edit</v-icon>Update
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn depressed fab small color="primary" outlined>
              <v-icon>help</v-icon>
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import collectService from "../service/CollectService";
import employeeService from "../service/EmployeeService";

export default {
  mounted: function () {
    employeeService.getAllDeliveryForCollect(this.itemId).then((data) => {
      this.employee.push(...data);
      this.loadCollect();
    });
  },
  data: () => {
    return {
      valid: false,
      employee: [],
      employeeRule: [(v) => !!v || "Employee is required"],
    };
  },
  props: {
    collect: {
      itemId: {
        type: Number,
        default: 0,
      },
      collectId: {
        type: Number,
        default: 0,
      },
      employeeDto: {
        type: Object,
        default: {
          userAccountId: {
            type: Number,
            default: 0,
          },
        },
      },
      remark: {
        type: String,
        default: "",
      },
      date: {
        type: String,
        default: "",
      },
      modifiedDate: {
        type: String,
        default: "",
      },
    },
    itemId: Number,
    loadCollect: Function,
    saveCollect: Function,
    updateCollect: Function,
  },
  methods: {
    clickHistoryEmployee: function () {
      employeeService.getAllDeliveryForCollect(this.itemId).then((data) => {
        this.employee.push(...data);
        this.loadCollect();
      });
    },
    beforeSaveCollect: function () {
      this.$refs.collectForm.validate();
      if (this.valid) {
        this.saveCollect();
      }
    },
    beforeUpdateCollect: function () {
      this.$refs.collectForm.validate();
      if (this.valid) {
        this.updateCollect();
      }
    },
    getAllDeliveryForCollect: function () {
      employeeService.getAllDeliveryForCollect(this.itemId).then((data) => {
        this.employee = this.employee.filter((v) => false);
        this.employee.push(...data);
        this.loadCollect();
      });
    },
  },
  computed: {},
};
</script>

<style scoped>
</style>